import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

const tdBaseCss = {
  height: '50px',
  fontSize: defaultTheme.font.size.s,
  verticalAlign: 'middle',
  textAlign: 'center',
  border: `solid ${defaultTheme.border.color.black}`,
  borderWidth: '1px 1px 0 0',
};

// td
export const BorderData = styled.td(
  (props: { isBorderRightNone?: boolean; isBorderLeftNone?: boolean }) =>
    mq({
      ...tdBaseCss,
      borderRight: props.isBorderRightNone ? 'none' : '',
      borderLeft: props.isBorderLeftNone ? 'none' : '',
    }),
);

// td
export const TableDataTextLeft = styled.td(() =>
  mq({
    ...tdBaseCss,
    borderWidth: '1px 0',
    textAlign: 'left',
    '& > div': {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      height: '99%',
      borderRight: `1px solid ${defaultTheme.border.color.mediumLightGray}`,
      '& > span': {
        paddingLeft: '8px',
      },
    },
  }),
);
